export const mapStyle = "mapbox://styles/mapbox/light-v10";
